<template>
  <div>
    <TitleField fieldName="isTrustee" :fieldGroup="fieldGroup" />
    <TrusteeSection :data="trusteeBase" documents-hidden />

    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="$v.assignee.status.$model"
          :errorMessages="getValidationErrorText($v.assignee.status)"
          :label="FieldLabel.ASSIGNEE_STATUS"
          outlined
        />
      </v-col>
    </v-row>

    <StatusDocument :v="$v.assignee.documents.statusDocument" />

    <slot name="footer" :next="nextHandler"></slot>
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import TrusteeSection from '@/components/elements/statement/FullStatementView/elements/Trustee';
import deepmerge from 'deepmerge';
import { FieldGroup } from '@/utils/fullStatementView';
import StatusDocument, {
  statusDocumentModel,
} from '@/components/services/elements/StatusDocument';
import { getAssigneeValidation } from '@/components/services/EgrnConfirm/Applicant/components/Assignee';
import { getValidationErrorText } from '@/utils/validate';
import { FieldLabel } from '@/constants';

export default {
  name: 'Assignee',
  components: {
    StatusDocument,
    TitleField,
    TrusteeSection,
  },
  props: {
    assigneeProp: {
      type: Object,
    },
    trusteeInfoProp: {
      type: Object,
    },
    fieldGroup: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    getValidationErrorText,
    FieldGroup,
    FieldLabel,
    assignee: {
      status: '',
      documents: {
        statusDocument: cloneDeep(statusDocumentModel),
      },
    },
  }),
  computed: {
    trusteeBase() {
      const trusteeProp = this.trusteeInfoProp || this.assigneeProp;

      return {
        lastName: trusteeProp.lastName,
        firstName: trusteeProp.firstName || trusteeProp.name,
        patronymic: trusteeProp.patronymic,
        snils: trusteeProp.snils,
        inn: trusteeProp.inn,
        email: trusteeProp.email,
        phone: trusteeProp.phone,
      };
    },
  },
  validations() {
    const assigneeValidation = getAssigneeValidation(this.assignee);

    return {
      assignee: {
        status: assigneeValidation.status,
        documents: assigneeValidation.documents,
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      if (this.assigneeProp) {
        this.assignee = deepmerge(this.assignee, this.assigneeProp);
      }
    },

    assemblyModel() {
      const trusteeProp = this.trusteeInfoProp || this.assigneeProp;

      return {
        lastName: trusteeProp.lastName,
        name: trusteeProp.firstName || trusteeProp.name,
        patronymic: trusteeProp.patronymic,
        snils: trusteeProp.snils,
        inn: trusteeProp.inn,
        email: trusteeProp.email,
        phone: trusteeProp.phone,
        status: this.assignee.status,
        documents: cloneDeep(this.assignee.documents),
      };
    },

    async nextHandler() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        await this.$vuetify.goTo('#header-target', { duration: 200 });
        return;
      }

      this.$emit('send', this.assemblyModel());
    },
  },
};
</script>
